import React, { createContext, useContext, useState, useCallback } from 'react';

interface SeoKeywordsEditorContextType {
  isOpen: boolean;
  openEditor: () => void;
  closeEditor: () => void;
}

const SeoKeywordsEditorContext = createContext<SeoKeywordsEditorContextType | undefined>(undefined);

export function SeoKeywordsEditorProvider({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  const openEditor = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeEditor = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <SeoKeywordsEditorContext.Provider
      value={{
        isOpen,
        openEditor,
        closeEditor,
      }}
    >
      {children}
    </SeoKeywordsEditorContext.Provider>
  );
}

export function useSeoKeywordsEditor() {
  const context = useContext(SeoKeywordsEditorContext);
  if (!context) {
    throw new Error('useSeoKeywordsEditor must be used within SeoKeywordsEditorProvider');
  }
  return context;
}
